import { iconName } from '@bt-react/components/Icon'

export enum direction {
  NEXT = 1,
  PREVIOUS = -1
}

export interface MediaCarouselState {
  carouselWidth: number
  itemElements: JSX.Element[]
  itemWidth: number
  itemsPerPage: number
  resizeListenerSet: boolean
  translateValue: number
  bias: direction
}

export interface MediaCarouselProps {
  empty?: {
    icon: iconName,
    message: string
  }
  isSidePanelOpen?: boolean
  items: JSX.Element[]
  hidden?: boolean
  selected: number
}
